import ImageCarousel from 'components/molecules/image-carousel'
import Overlay from 'components/molecules/overlay'
import OverlaysContainer from 'components/redux-containers/overlays-container'
import useCarouselKeyboardNavigation from 'hooks/use-carousel-keyboard-navigation'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components/macro'
import { ImageSetTypeEnum } from 'config/enums'
import { getRegularCarImages } from 'utilities/utils'

const ImageOverlay = styled(Overlay)`
  height: 100vh;
`

const StyledImageCarousel = styled(ImageCarousel)`
  height: 100vh;
`

function LayoutOverlays({ carAssets, closeImageOverlay, closeSearchbox, ui }) {
  const carouselRef = useRef(null)

  const b2bCarImages = useSelector((state) =>
    Array.isArray(state?.data?.b2bCarFileAssets?.data)
      ? state.data.b2bCarFileAssets.data.filter(({ type }) => type === 'image')
      : [],
  )
  const carImages =
    ui.carouselImages ||
    (ui.imagesSetType === ImageSetTypeEnum.B2B_CAR_FILE
      ? b2bCarImages
      : carAssets && getRegularCarImages(carAssets.data))

  // Only show the layout overlay for REGULAR_CAR_FILE or B2B_CAR_FILE, other type of images.
  // This is to prevent the layout overlay from being shown for damage images or generic images which uses the same state but renders different components.
  const showCarImagesOverlay =
    ui.imageOverlayOpen &&
    (ui.imagesSetType === ImageSetTypeEnum.REGULAR_CAR_FILE ||
      ui.imagesSetType === ImageSetTypeEnum.B2B_CAR_FILE)

  useCarouselKeyboardNavigation({
    carouselRef,
    isOpen: showCarImagesOverlay,
    onClose: closeImageOverlay,
  })

  return (
    <>
      {showCarImagesOverlay && (
        <ImageOverlay close={closeImageOverlay}>
          {carImages && (
            <StyledImageCarousel
              ref={carouselRef}
              images={carImages}
              initialSlide={ui.imageOverlayImageIdx}
              fullHeight
              arrows
            />
          )}
        </ImageOverlay>
      )}
      {ui.overlay && <OverlaysContainer overlay={ui.overlay} />}
    </>
  )
}

LayoutOverlays.propTypes = {
  carAssets: PropTypes.object,
  closeImageOverlay: PropTypes.func.isRequired,
  closeSearchbox: PropTypes.func.isRequired,
  ui: PropTypes.object.isRequired,
}

LayoutOverlays.defaultProps = {
  carAssets: null,
}

export default LayoutOverlays
